import {pdfjs} from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = "/static/pdf.worker.min.js";

export {pdfjs};
